import { RouteRecordRaw } from 'vue-router';
import EvalQbank from '@/views/eval_qbank/index.vue';

/**
 * staticRouter
 */
export const staticRouter = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/note/review',
        name: 'noteReview',
        component: () => import('@/views/myNote/myNoteReview.vue'),
        meta: {
            title: '풀이',
        },
    },
    {
        path: '/report/review',
        name: 'review',
        component: () => import('@/views/report/review.vue'),
        meta: {
            title: '풀이',
        },
    },
    {
        path: '/explainList/viewPassage',
        name: 'viewPassage',
        component: () => import('@/views/explainList/viewPassage.vue'),
        meta: {
            title: '작품해설자료',
        },
    },

    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index.vue'),
        meta: {
            title: '로그인',
        },
    },
    {
        path: '/growthplateLogin',
        name: 'growthplateLogin',
        component: () => import('@/views/login/growthplateLogin.vue'),
        meta: {
            title: '성장판앱 로그인',
        },
    },
    {
        path: '/macadamia-login',
        name: 'macadamiaLogin',
        component: () => import('@/views/login/macadamiaLogin.vue'),
        meta: {
            title: '마카다미아 로그인',
        },
    },
    {
        path: '/krt-login',
        name: 'externalLogin',
        component: () => import('@/views/login/externalLogin.vue'),
        meta: {
            title: '외부접근 로그인',
        },
    },
    {
        //2023-12-07 pby KRT-2145 수능독해 체험 회원들이 접근할 수 있도록 아래와 같이 사이트 주소 변경
        path: '/exp-login',
        name: 'trialAccount',
        component: () => import('@/views/login/index_trial_account.vue'),
        meta: {
            title: '체험계정 로그인',
        },
    },
    {
        path: '/inspect',
        name: 'inspect',
        component: () => import('@/views/inspect/InspectProblem.vue'),
        meta: {
            title: '문항검사',
        },
    },
    // {
    //     path: '/testc',
    //     name: 'testc',
    //     component: () => import('@/views/testCore/index.vue'),
    //     meta: {
    //         title: '문항검사1',
    //     },
    // },
    // {
    //     path: '/tests',
    //     name: 'tests',
    //     component: () => import('@/views/testSat/index.vue'),
    //     meta: {
    //         title: '문항검사2',
    //     },
    // },
    // {
    //     path: '/testa',
    //     name: 'testa',
    //     component: () => import('@/views/testAuthentic/index.vue'),
    //     meta: {
    //         title: '문항검사3',
    //     },
    // },

    // {
    //     path: '/signup',
    //     name: 'signup',
    //     component: () => import('@/views/signup/index.vue'),
    //     meta: {
    //         title: '회원가입',
    //     },
    // },

    // {
    //     path: '/eval-test',
    //     name: 'evaltest',
    //     displayName: 'My Display Name',
    //     component: () => EvalQbank,
    //     meta: {
    //         title: '진단평가',
    //     },
    // },
    // {
    //     path: '/evaltest3',
    //     name: 'evaltest3',
    //     component: () => import('@/views/eval_qbank/index.vue'),
    //     meta: {
    //         title: '진단평가_테스트_cutom',
    //     },
    // },
];

/**
 * errorRouter
 */
export const errorRouter = [
    {
        path: '/403',
        name: '403',
        component: () => import('@/components/errorMessage/403.vue'),
        meta: {
            title: '403에러',
        },
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/components/errorMessage/404.vue'),
        meta: {
            title: '404에러',
        },
    },
    {
        path: '/500',
        name: '500',
        component: () => import('@/components/errorMessage/500.vue'),
        meta: {
            title: '500에러',
        },
    },
];

export const notFoundRouter = {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    redirect: { name: '404' },
};
